import React from "react";
import { useSelector } from "react-redux";
import qs from "query-string";
import DateFilterWrap from "components/DateFilter/wrap";
import get from "lodash/get";
import dayjs from "dayjs";
import useTranslation from "hooks/useTranslation";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "services/api";
import Spinner from "components/Spinner";
import TableRestaurantInventoryMetrics from "pages/Main/Storage/components/TableRestaurantInventoryMetrics";
import { stringify, parse } from "qs";
import classNames from "classnames";

const InventoryMetrics = ({ incomes, adjustment, index, currency }) => {
	const { tr } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const query = parse(location.search, { ignoreQueryPrefix: true });

	return (
		<div className="bg-gray-100 overflow-hidden !rounded-md !border-4 !border-gray-900">
			<div className="bg-gray-200 p-3 border-b border-gray-300 border-l-4 border-l-blue-500">
				<h3 className="mb-0 text-xl font-medium">
					{index + 1}. {get(incomes, "name")}
				</h3>
			</div>

			<div className="py-5 px-7">
				<TableRestaurantInventoryMetrics
					data={incomes}
					title={tr("Приход")}
					currency={currency}
					type="coming"
					onStorageClick={storage => {
						navigate({
							pathname: `/storage/incomes/${storage.id}`,
							search: stringify({
								type: "coming",
								start_at: query.start_at,
								end_at: query.end_at
							})
						});
					}}
				/>
				<TableRestaurantInventoryMetrics
					data={adjustment}
					title={tr("Инвентаризация")}
					currency={currency}
					type="adjustment"
					onStorageClick={storage => {
						navigate({
							pathname: `/storage/incomes/${storage.id}`,
							search: stringify({
								type: "adjustment",
								start_at: query.start_at,
								end_at: query.end_at
							})
						});
					}}
				/>
			</div>
		</div>
	);
};

function MainOrganizationStorageIncomes({ isMainPage }) {
	const { tr } = useTranslation();
	const location = useLocation();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });
	const default_currency_code = useSelector(
		state => state.auth.default_currency_code
	);
	const currency = default_currency_code && default_currency_code.toUpperCase();

	const startAt =
		query.start_at ||
		dayjs()
			.startOf("day")
			.unix();
	const endAt =
		query.end_at ||
		dayjs()
			.endOf("day")
			.unix();

	const queryStorageComings = useQuery({
		queryKey: ["queryStorageComings", startAt, endAt],
		queryFn: () =>
			api.request({
				url: "/main/reports/comings",
				params: {
					sort: "id",
					limit: 100,
					start_at: startAt,
					end_at: endAt
				}
			})
	});

	const incomes = get(queryStorageComings, "data.data", {});

	if (queryStorageComings.status === "loading") {
		return (
			<div className="flex justify-center items-center h-[300px]">
				<Spinner />
			</div>
		);
	}

	return (
		<div>
			{isMainPage ? null : (
				<div className="flex items-center gap-5 mb-20">
					<DateFilterWrap
						initialDefault={"day"}
						withStartHoursAppended={true}
						navigateByDay={true}
					/>
					<h3 className="my-0 font-bold text-xl">{tr("Приход товаров")}</h3>
				</div>
			)}

			<div
				className={classNames({
					"d-panel": !isMainPage
				})}
			>
				<div className="grid grid-cols-1 gap-10">
					{get(incomes, "comings", []).map((coming, idx) => (
						<InventoryMetrics
							key={idx}
							incomes={coming}
							adjustment={get(incomes, `adjustments.${idx}`, [])}
							index={idx}
							currency={currency}
							//
						/>
					))}
				</div>
			</div>
		</div>
	);
}

export default MainOrganizationStorageIncomes;
